import { render, staticRenderFns } from "./BuildingCollectionModal.vue?vue&type=template&id=9a071e38&scoped=true"
import script from "./BuildingCollectionModal.vue?vue&type=script&lang=js"
export * from "./BuildingCollectionModal.vue?vue&type=script&lang=js"
import style0 from "./BuildingCollectionModal.vue?vue&type=style&index=0&id=9a071e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a071e38",
  null
  
)

export default component.exports